import { SearchOutlined } from '@ant-design/icons'
import { Col, Input, Row } from 'antd'
import React from 'react'

export default function SearchControl({ handleInputChange, searchText }) {
  
    return (
        <>
            <Row>
                <Col xs={24} md={8}>
                    <Input
                        placeholder="Provide search text"
                        type="text"
                        className="search-bar"
                        onChange={handleInputChange}
                        value={searchText}
                        allowClear
                        size="large"
                        prefix={<SearchOutlined />}
                        name=''
                    />
                </Col>
            </Row>
        </>
    )
}
